import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ENDPOINTS } from '../@config/endpoints';
import { ContactEntry, ContactResult, ContactSearchModel } from '../@models';
import { Pagination } from '../@config';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private http: HttpClient) { }
  getContacts(skipCount: number, searchFilter: any): Observable<ContactResult> {
    return this.http.get<ContactResult>(ENDPOINTS.getContacts(Pagination.maxResultCount, skipCount, searchFilter.payload || "")).pipe(
      map((respone: any) => respone?.result || []));
  }

  getAll(maxResultCount: number, skipCount: number,  searchText?: string): Observable<ContactEntry[]> {
    return this.http.get<ContactEntry[]>(ENDPOINTS.getContacts(maxResultCount, skipCount, searchText || '')).pipe(
      map((respone: any) => respone?.result?.items || []));
  }

  getContactById(contactId: number): Observable<ContactEntry> {
    return this.http.get<ContactEntry>(ENDPOINTS.getContactById(contactId)).pipe(
      map((respone: any) => respone?.result || {}));
  }

  getAllContactsByCustomerId(maxResultCount: number, skipCount: number,  searchText?: string, customerId?: number): Observable<ContactEntry[]> {
    return this.http.get<ContactEntry[]>(ENDPOINTS.getContactsByCustomerId(maxResultCount, skipCount, searchText || '', customerId)).pipe(
      map((respone: any) => respone?.result?.items || []));
  }
}
